import { z } from 'zod';
import { emptyToNull } from './empty-to-null';

/**
 * Reusable schema for Strings that can be null.
 *
 * Validation Pipeline:
 * 1. Preprocess: Cleans and normalizes invalid strings (e.g., 'n/a', 'unknown') by converting them to actual 'null' through the `emptyToNull` helper.
 * 2. Validate: Ensures that the value is strictly a valid `string` or `null`.
 */
export const nullableString = z.preprocess(emptyToNull, z.string().nullable());
